module.exports = __webpack_public_path__ + "img/booking.50c2ceac.png";